import type { PerformanceOverview_component$key } from '@generated/PerformanceOverview_component.graphql';

export interface DataPropsGeneric<T extends Date | string> {
  date: T;
  performance: number;
  benchmark?: number;
}

export type XDomainGeneric<T extends Date> = [T, T];

export type XDomain = XDomainGeneric<Date>;

export type YDomain = [number, number];
export type XRange = [number, number];
export type YRange = [number, number];
export type DataProps = DataPropsGeneric<string>;
export type ParsedDataProps = DataPropsGeneric<Date>;

export enum HighlightLinePresets {
  NOTHING = 0,
  PERFORMANCE = 1,
  BENCHMARK = 2,
}

export enum DatePresets {
  Week = 0,
  Month = 1,
  SixMonths = 2,
  Year = 3,
  StartOfYear = 4,
  ThreeYears = 5,
  TenYears = 6,
  Beginning = 7,
}

export interface Margins {
  left: number;
  right: number;
  top: number;
  bottom: number;
}

export interface PerformanceOverviewProps {
  component: PerformanceOverview_component$key;
  path: string;
  reportcurrency: string;
  reportCurrency: string;
  location: any;
  currentLanguage: string;
  margins: Margins;
}

export interface InfoValues {
  performance: number;
  performancePA: number;
  benchmark: number;
  benchmarkPA: number;
}
